<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Gateway de Pagamento</h3>
    <h4 class="ui header">Cartão de Crédito</h4>
    <div class="ui divider"></div>
    <div class="field">
      <label for="invoice-days-before-setting"> Gateway de Pagamento </label>
      <select
        id="payment-gateway-gateway-setting"
        name="payment-gateway-gateway-setting"
        v-model="form.gateway"
      >
        <option
          v-for="(payment_gateway, index) in payment_gateways"
          :key="index"
          :value="payment_gateway.name"
        >
          {{ payment_gateway.description }}
        </option>
      </select>
    </div>
    <div class="field" v-for="(option, index) in gateway.options" :key="index">
      <label :for="`payment-gateway-option-${option.name}`">
        {{ option.description }}
      </label>
      <input
        type="text"
        v-model="option.value"
        :id="`payment-gateway-option-${option.name}`"
      />
    </div>
    <h4 class="ui header">Boleto Bancário</h4>
    <div class="ui divider"></div>
    <div class="field">
      <label for="payment-gateway-boleto-gateway-setting">
        Gateway de Pagamento
      </label>
      <select
        id="payment-gateway-boleto-gateway-setting"
        name="payment-gateway-boleto-gateway-setting"
        v-model="form.boleto_gateway"
      >
        <option
          v-for="(payment_gateway, index) in payment_gateways"
          :key="index"
          :value="payment_gateway.name"
        >
          {{ payment_gateway.description }}
        </option>
      </select>
    </div>
    <div
      class="field"
      v-for="(option, index) in boleto_gateway.options"
      :key="`boleto-gateway-option-${index}`"
    >
      <label :for="`payment-boleto-gateway-option-${option.name}`">
        {{ option.description }}
      </label>
      <input
        type="text"
        v-model="option.value"
        :id="`payment-boleto-gateway-option-${option.name}`"
      />
    </div>
    <h4 class="ui header">Outras condições de pagamento</h4>
    <div class="ui divider"></div>
    <div
      v-for="(gateway, index) in form.extra_gateways"
      :key="`gateway-${index}`"
      class="fields"
    >
      <div class="field">
        <label>Chave</label>
        <input v-model="gateway.name" type="text" />
      </div>
      <div class="field">
        <label>Descrição</label>
        <input v-model="gateway.description" type="text" />
      </div>
      <div class="field" style="padding-top: 29px">
        <JSONEditor
          :value="gateway"
          @save="jsonObj => $set(form.extra_gateways, index, jsonObj)"
        >
          <template v-slot:activator="{ open }">
            <a title="Edito JSON" @click.prevent="open">
              <i class="edit icon"></i>
            </a>
          </template>
        </JSONEditor>
      </div>
      <div class="remove field">
        <a
          class="delete"
          title="Remover"
          @click.prevent="removeExtraGateway(index)"
          ><i class="trash icon"></i
        ></a>
      </div>
    </div>
    <a href="#" @click.prevent="addExtraGateway">
      <i class="plus icon"></i> Adicionar
    </a>
  </form>
</template>
<script>
import JSONEditor from '@/components/json_editor';
const PAYMENT_GATEWAYS = [
  {
    name: 'pagarme',
    description: 'PagarMe',
    options: [
      {
        name: 'api_key',
        value: null,
        description: 'API Key'
      },
      {
        name: 'secret_key',
        value: null,
        description: 'Secret Key'
      },
      {
        name: 'version',
        value: null,
        description: 'Versão'
      }
    ]
  },
  {
    name: 'gerencianet',
    description: 'GerenciaNet',
    options: []
  }
];

export default {
  components: { JSONEditor },
  data() {
    return {
      payment_gateways: PAYMENT_GATEWAYS,
      form: {
        boleto_gateway: null,
        gateway: null,
        extra_gateways: []
      }
    };
  },

  computed: {
    gateway() {
      const gateways = JSON.parse(JSON.stringify(PAYMENT_GATEWAYS));
      return gateways.find(p => this.form.gateway == p.name) || {};
    },

    boleto_gateway() {
      const gateways = JSON.parse(JSON.stringify(PAYMENT_GATEWAYS));
      return gateways.find(p => this.form.boleto_gateway == p.name) || {};
    }
  },

  methods: {
    // load Data
    addExtraGateway() {
      this.form.extra_gateways.push({
        name: null,
        description: null,
        credentials: null
      });
    },

    removeExtraGateway(index) {
      this.$delete(this.form.extra_gateways, index);
    },

    setForm(settings) {
      const gatewaySetting =
        settings.find(s => s.key == 'payment_gateway_provider') || {};

      this.form.gateway = gatewaySetting.response;

      let optionsSetting = settings.find(
        s => s.key == 'payment_gateway_options'
      );

      if (optionsSetting != null && this.form.gateway != null) {
        optionsSetting = JSON.parse(optionsSetting.response) || {};
        Object.keys(optionsSetting).forEach(optionKey => {
          const option = this.gateway.options.find(o => o.name == optionKey);
          if (option != null) {
            option.value = optionsSetting[optionKey];
          }
        });
      }

      let extraGatewaysSetting = settings.find(
        s => s.key == 'payment_extra_gateways'
      );
      if (extraGatewaysSetting != null) {
        extraGatewaysSetting = JSON.parse(extraGatewaysSetting.response);
        this.form.extra_gateways = extraGatewaysSetting || [];
      }

      // set boleto
      const boletoGatewaySetting =
        settings.find(s => s.key == 'payment_boleto_gateway_provider') || {};

      this.form.boleto_gateway = boletoGatewaySetting.response;

      let boletoOptionsSetting = settings.find(
        s => s.key == 'payment_boleto_gateway_options'
      );

      if (boletoOptionsSetting != null) {
        boletoOptionsSetting = JSON.parse(boletoOptionsSetting.response);
        if (boletoOptionsSetting != null && this.form.boleto_gateway != null) {
          Object.keys(boletoOptionsSetting).forEach(optionKey => {
            const option = this.boleto_gateway.options.find(
              x => x.name == optionKey
            );
            if (option != null) {
              option.value = boletoOptionsSetting[optionKey];
            }
          });
        }
      }
    },

    getSettings() {
      const options = {};

      if (this.gateway.options != null) {
        this.gateway.options.forEach(option => {
          options[option.name] = option.value;
        });
      }

      const result = {
        payment_gateway_provider: this.form.gateway,
        payment_gateway_options: options,
        payment_extra_gateways: this.form.extra_gateways.filter(
          e => e.name != null && e.description != null
        )
      };

      result.payment_boleto_gateway_provider = this.form.boleto_gateway;

      if (this.boleto_gateway.options != null) {
        const boletoGatewayOptions = {};
        this.boleto_gateway.options.forEach(option => {
          boletoGatewayOptions[option.name] = option.value;
        });

        result.payment_boleto_gateway_options = boletoGatewayOptions;
      }

      return result;
    }
  }
};
</script>
